// app/frontend/js/leaflet.js
import L from 'leaflet';
window.L = L;
export default L;